<div class="pdf-view-container">
    <div class="dialog-close" (click)="close()">
        <div id="btn-cancel" class="fab small active" >
            <i class="fas fa-times"></i>
        </div>
    </div>
    <iframe id="PDFviewer" style="width: 100%; height: 100%;"></iframe>
</div>
